import $ from 'jquery';

var CheckoutForm = function ($form) {

  const paymentMethodsForDeliveryMethod = {
    'np_standart': ['cod', 'online'],
    'pickup': ['online', 'cash'],
    'kiev_courier': ['online', 'cash'],
  };

  var self = this;

  this.form = null;
  this.deliveryElement = null;
  this.addressContainer = null;
  this.paymentElement = null;


  function init($form) {
    self.form = $form;
    self.initDelivery();
    self.initPayment();
  }

  this.initDelivery = function() {
    self.deliveryElement = self.form.find('#checkout_shipping_method');
    this.addressContainer = self.form.find('.delivery__address');

    self.deliveryElement.on('change', resetInputAddressContainer);
    self.deliveryElement.on('change', changeAttributeAddressContainer);
    self.deliveryElement.on('change', resetPaymentMethod);
    self.deliveryElement.on('change', updateAvailablePaymentMethod);
  };

  this.initPayment = function() {
    self.paymentElement = self.form.find('#checkout_payment_method');
    resetPaymentMethod();
    updateAvailablePaymentMethod();
  };

  function changeAttributeAddressContainer() {
    let value = self.deliveryElement.val();
    self.addressContainer.attr('data-shipping-method', value);
  }

  function resetInputAddressContainer() {
    self.addressContainer.find('input').val('');
  }


  function updateAvailablePaymentMethod() {
    let deliveryMethod = self.deliveryElement.val();
    let availablePaymehtMethod = paymentMethodsForDeliveryMethod[deliveryMethod] || [];

    self.paymentElement.find('option').attr('disabled', true);
    for(let i = 0; i < availablePaymehtMethod.length; i++) {
      let paymentMethodCod = availablePaymehtMethod[i];
      self.paymentElement.find('option[value=' + paymentMethodCod + ']').attr('disabled', false);
    }

  }

  function resetPaymentMethod() {

    if(self.paymentElement.val()) {
      return;
    }

    let options = self.paymentElement.find('option');
    self.paymentElement.val('');
    options.each(function(index, element) {
      if($(element).val()) {
        $(element).attr({disabled: true, selected: false});
      }
    })
  }


  return {
    init: init,
  };
};

$(document).ready(function() {
  var checkoytForm = new CheckoutForm();
  checkoytForm.init($('[name=checkout]'));
});



// WEBPACK FOOTER //
// ./frontend/src/checkout/checkout.js